import { createContext, useContext } from "react";
export const EsmAccessContext = createContext(false);
export const useEsmAccess = () => useContext(EsmAccessContext);
